import { animate, style, transition, trigger } from '@angular/animations';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AdvancedSearchContainerData, AdvancedSearchFormData, KeyValue } from '../../models/common';
import { SearchCardI } from '../../models/list-view/kanbanList';

@Component({
  selector: 'antera-lib-kanban-search',
  templateUrl: './kanban-search.component.html',
  styleUrls: ['./kanban-search.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateX(-100%)'}),
        animate('400ms ease-in', style({transform: 'translateX(-100%)'}))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({transform: 'translateX(-100%)'}))
      ])
    ])
  ]
})

export class KanbanSearchComponent implements OnInit {

  @Input() savedSearchList: SearchCardI[] = [];
  @Input() display: boolean = false;
  @Input() savedSearch: any;
  @Input() advancedSearchFormData: AdvancedSearchFormData = {
    title: '',
    description: '',
    filters: [{ name: '', hint: '' }],
  };

  @Input() anteraFilterOptions: KeyValue[] = [];
  @Input() advancedSearchContainerData:AdvancedSearchContainerData = {
    advancedSearchContainer: '',
    titleAdvancedSearch: '',
    excerptAdvancedSearch: ''
  };
  @Input() public selectedIndex: number = 0;
  @Input() public page: string = '';
  @Input() public mappingFields: any[] =  [];
  
  @Output() public onCardDeleted: EventEmitter<any> = new EventEmitter();
  @Output() public onSelectClicked: EventEmitter<any> = new EventEmitter();
  @Output() public onAdvancedSearch: EventEmitter<any> = new EventEmitter();
  @Output() public onSavedSearchQuickViewEnabled: EventEmitter<any> = new EventEmitter();
  @Output() public onSavedSearchShare: EventEmitter<any> = new EventEmitter();
  @Output() public onSavedSearchReorder: EventEmitter<any>  = new EventEmitter();
  @Output() public onCardHide: EventEmitter<any>  = new EventEmitter();
  @Output() public autoCompleteSearch: EventEmitter<any>  = new EventEmitter();
  @Input() public showProductDeleted: number = 0;
  @Input() public reSynceNeeded = false;
  @Output() public ontToggleResyncQBO: EventEmitter<any> = new EventEmitter();
  @Input() public qboActive = false;
  @Output() public onToggleAccountType: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }


/**
 * Delete emitted.
 *
 * @param {SearchCardI} event
 * @returns {void}
 */
  public onDeleteSavedSearch(event: SearchCardI){
    this.onCardDeleted.emit(event);
  }

  public onHideSavedSearch(event: SearchCardI){
    this.onCardHide.emit(event);
  }


  /**
   * Select emitted.
   *
   * @param {SearchCardI} event
   * @returns {void}
   */
  public onSelectBtnClicked(event: SearchCardI){
    this.onSelectClicked.emit(event);
  }

  /**
   * Emits advanced search form details.
   *
   * @param {any} searchValue
   * @returns {void}
   */

  public emitAdvancedSearchValues(searchValue: any){
    this.onAdvancedSearch.emit(searchValue);
  }

  /**
   * Search Card quick view enabled. Emit vard details and
   * checkbox value
   *
   * @param {any}
   * @returns {void}
   */
  public onSavedSearchEnableQuickView(event: any): void{
    this.onSavedSearchQuickViewEnabled.emit(event);
  }

  /**
   *
   */
  public onSavedSearchCardOrderChange(event: any) {
    moveItemInArray(this.savedSearchList, event.previousIndex, event.currentIndex);
    this.savedSearchList.forEach((card, index) => card.order = index);
    this.onSavedSearchReorder.emit({cardList: this.savedSearchList});
  }

  public onShareToggle(event: any) {
    this.onSavedSearchShare.emit(event)
  }

  public emitAutoComplete(event: any) {
    this.autoCompleteSearch.emit(event);
  }

  public toggleResyncQBO(event: any) {
    this.ontToggleResyncQBO.emit(event);
  }

  public changeAccType(event: any) {
    this.onToggleAccountType.emit(event);
  }
}
